export default __webpack_public_path__ + "static/media/ic_micronesia.ef555fb7.svg";